export const sq = {
  common: {
    appName: "eSHËNDETËSIA",
    search: "Kërko",
    searchPlaceholder: "Kërko në aplikacion...",
    favorites: "Favoritet",
    notifications: "Njoftime",
    noNewNotifications: "Nuk ka njoftime të reja",
    messages: "Mesazhe",
    cart: "Shporta",
    logout: "Dil nga llogaria",
    session: "Sesioni",
    settings: "Cilësimet",
    theme: "Tema",
    language: "Gjuha",
    inDevelopment: "Në zhvillim",
    loading: "Duke ngarkuar...",
    save: "Ruaj",
    cancel: "Anulo",
    confirm: "Konfirmo",
    delete: "Fshi",
    edit: "Ndrysho",
    close: "Mbyll",
    back: "Kthehu",
    next: "Tjetër",
    submit: "Dërgo",
    activate: "Aktivizo",
    register: "Regjistrohu",
    apply: "Apliko",
    book: "Rezervo",
    pay: "Paguaj",
    download: "Shkarko",
    upload: "Ngarko",
    share: "Ndaj",
    view: "Shiko",
    filter: "Filtro",
    sortBy: "Rendit sipas",
    all: "Të gjitha",
    active: "Aktiv",
    inactive: "Joaktiv",
    pending: "Në pritje",
    completed: "I kryer",
    cancelled: "I anuluar",
    free: "Falas",
    noData: "Nuk ka të dhëna",
    error: "Gabim",
    tenantScopeDenied: "Qasja e kufizuar në nivel klinike.",
    success: "Sukses",
    required: "I detyrueshëm",
    optional: "Opsional",
    eur: "EUR",
  },
  appointment_created: "Termini u krijua me sukses dhe u regjistrua ne agjenden mjekesore.",
  laboratory_case_created: "Rasti laboratorik u krijua dhe eshte ne pritje te perpunimit.",
  laboratory_results_ready: "Rezultatet laboratorike jane gati per shqyrtim klinik.",
  laboratory_case_delivered: "Rezultatet laboratorike iu dorëzuan pacientit.",
  payment_success: "Pagesa u krye me sukses.",
  LARGE_TRANSACTION: "U identifikua një transaksion i madh që kërkon vëmendje.",
  service_subscription_activated: "Pajtimi i modulit u aktivizua.",
  service_subscription_expired: "Pajtimi i modulit ka skaduar.",
  inventory_incident_reported: "U raportua një incident për pajisjen.",
  business_invoice_created: "U krijua një faturë e re B2B.",
  verification: {
    requestedSuccess: "Kërkesa juaj u dërgua te administratori.",
    requirementsMissing: "Për të kërkuar verifikimin, duhet të jeni anëtar i një klinike të verifikuar.",
  },
  security: {
    setPin: "Vendos PIN-in",
    pinRequired: "Ju lutem vendosni PIN-in për të zhbllokuar editimin e profilit.",
    pinSuccess: "PIN-i u ruajt.",
  },
  media: {
    uploading: "Duke ngarkuar skedarin...",
    allowedImageFormat: "Format i lejuar: JPG, PNG",
    uploadSuccess: "Skedari u ruajt me sukses",
    uploadFile: "Ngarko skedarin",
    dropOrClick: "Klikoni ose terhiqni skedarin ketu",
  },
  showcase: {
    hero: {
      badge: "✦ Platforma shëndetësore #1 · Kosovë",
      reserve: "Rezervo tani",
      dotsLabel: "Zgjidh slide",
      slides: {
        speed: {
          title: "Rezervo Online Vizitë Mjekësore",
          subtitle: "Gjej termin të lirë, zgjedh mjekun dhe konfirmo vizitën brenda pak sekondave.",
          button: "Rezervo tani",
        },
        nearby: {
          title: "Gjej specialistët më të afërt",
          subtitle: "Kërko sipas qytetit, specializimit dhe distancës për të gjetur kujdesin më të afërt.",
          button: "Gjej specialistin",
        },
        vault: {
          title: "Dosja juaj mjekësore, 100% e sigurt",
          subtitle: "Raportet, analizat dhe historia klinike ruhen në Vault të blinduar dhe të qasshëm vetëm për ju.",
          button: "Hap historinë time",
        },
      },
    },
  },
  ads: {
    selectOwner: "Zgjidh pronarin pagues",
    selectPriority: "Zgjidh prioritetin",
    errorOwnerNotFound: "Llogaria paguese nuk u gjet. Zgjidhni një pronar të vlefshëm nga lista.",
    requestAd: "Kërko Reklamë",
    platformInternal: "Reklamë e platformës",
    pendingApproval: "Në pritje",
    pendingPayment: "Reklama është krijuar, duke pritur pagesën e faturës.",
    requestSent: "Kërkesa u dërgua. Ju lutem paguani faturën te seksioni i faturave për t'u shqyrtuar.",
    waitingApproval: "në pritje të aprovimit",
    marketingTab: "Marketing & Promovimi",
    marketing: "Marketing",
    payConfirm: "A jeni i sigurt që dëshironi ta paguani këtë faturë nga Wallet-i?",
    cancelSuccess: "Kërkesa u anulua me sukses.",
  },
  medimarket: {
    orderCompleted: "Porosia u krye",
    walletPaymentCompleted: "Pagesa u krye me sukses nga Wallet-i.",
    trackingCode: "Kodi i gjurmimit",
    requiresPrescription: "Kërkohet recetë mjekësore",
  },
  inventory: {
    title: "Pajisjet Mjekësore",
    eyebrow: "Smart Inventory",
    description: "Gjurmoni asetet, ciklin e jetës, mirëmbajtjen dhe QR-kodet e çdo pajisjeje.",
    upgradeTitle: "Smart Inventory",
    upgradeDescription: "Ky modul kërkon abonimin aktiv Inventory te Service Hub. Menaxhoni asetet mjekësore, mirëmbajtjen dhe QR me një klik.",
    activateFromHub: "Aktivizo nga Service Hub",
    searchPlaceholder: "Kërko: pajisja, seriali, kategoria",
    statusAll: "Statusi: Të gjitha",
    criticalityAll: "Kriticiteti: Të gjitha",
    scanQr: "Skanim QR",
    newAsset: "Pajisje e Re",
    loading: "Duke ngarkuar...",
    empty: "Nuk u gjet asnjë pajisje.",
    count: "{{count}} pajisje",
    headers: {
      assetId: "Asset ID",
      device: "Pajisja",
      brandModel: "Brendi / Modeli",
      status: "Statusi",
      location: "Lokacioni",
      criticality: "Kriticiteti",
      warranty: "Garancioni",
    },
    detail: {
      selectAsset: "Zgjidh një pajisje nga lista.",
      tabs: {
        overview: "Detaje",
        maintenance: "Mirëmbajtje",
        history: "Historia",
      },
      fields: {
        custody: "Kujdestaria",
        location: "Lokacioni",
        serial: "Seriali",
        brand: "Brendi",
        model: "Modeli",
        purchaseDate: "Data e Blerjes",
        warranty: "Garancioni",
        department: "Departamenti",
        assignee: "Përgjegjësi",
        created: "Krijuar",
        updated: "Përditësuar",
      },
      chooseStatus: "Zgjidh statusin...",
      sendToService: "Dërgo në Servis",
      serviceDescriptionPlaceholder: "Përshkruaj problemin ose servisimin",
      technicianNotesPlaceholder: "Shënime tekniku",
      registering: "Duke regjistruar...",
      reportIncident: "Raporto Incident",
      incidentDescriptionPlaceholder: "Përshkruaj incidentin",
      downloadQr: "Shkarko QR",
      qrSecurityNote: "Skanimi verifikohet në backend para se të hapen detajet.",
    },
  },
  imaging: {
    roleBanner: "Keni hyrë në modulin e imazherisë si {{role}}",
    upload: {
      title: "Ngarko Studim Imazherik",
      patientId: "ID Pacienti *",
      patientPlaceholder: "p.sh. 384",
      studyType: "Lloji i Studimit *",
      bodyPart: "Pjesa e Trupit *",
      bodyPartPlaceholder: "p.sh. Gjoks, Gjuri i majtë, Koka",
      clinicalNote: "Shënim Klinik (opsional)",
      clinicalNotePlaceholder: "Gjetje klinike, observime...",
      dropHint: "Klikoni ose tërhiqni imazhin këtu",
      fileHint: "JPG, PNG, WEBP · max 15 MB",
      submit: "Ngarko Studimin",
      errors: {
        fileType: "Vetëm JPG, PNG ose WEBP lejohen.",
        fileSize: "Skedari tejkalon 15 MB.",
        patientRequired: "ID e pacientit është e detyrueshme.",
        bodyPartRequired: "Pjesa e trupit është e detyrueshme.",
        fileRequired: "Zgjidhni skedarin imazh.",
        failed: "Ngarkimi dështoi. Provoni sërish.",
      },
    },
  },
  messagesPage: {
    eyebrow: "MSN i Sigurt",
    title: "Mesazhet",
    description: "Biseda private pacient-profesionist, të hapura vetëm me kontekst klinik.",
    reconnecting: "Lidhja u ndërpre. Ritentativë {{current}}/{{max}}...",
    failedReconnect: "Lidhja dështoi pas 5 tentativave. Rinisni faqen.",
  },
  superadmin: {
    verifyBusiness: "Verifiko",
    moduleApprovals: "Aprovimet e Moduleve",
    activateModule: "Aktivizo Modulin",
  },
  billing: {
    b2bInvoices: "Fatura B2B SaaS",
    vat: "TVSH",
    paymentSuccessful: "Pagesa u krye me sukses.",
  },
  business: {
    licenseUsage: "Përdorimi i Licencave",
    doctorLimit: "Limiti i mjekëve",
    usedSeats: "Licencat e përdorura",
  },
  themes: {
    lightFlat: "Light",
    dark: "Dark",
    gradientLight: "Gradient",
  },
  languages: {
    sq: "SQ",
    en: "EN",
    sr: "SR",
    tr: "TR",
  },
  roles: {
    business: "Biznes",
    doctor: "Mjek",
    specialist: "Specialist",
    technician: "Teknik",
    patient: "Pacient",
    admin: "Administratë",
    superadmin: "Superadmin",
    student: "Student",
    guest: "Vizitor",
    none: "Pa profil aktiv",
  },
  nav: {
    dashboard: "Dashboard",
    corporateDashboard: "Dashboard Korporativ",
    search: "Kërko",
    patientHome: "Faqja ime",
    professionalPanel: "Paneli im",
    appointments: "Terminet",
    monitoring: "Monitorimi",
    familyCare: "Kujdesi familjar",
    clinicalHistory: "Historiku Klinik",
    laboratory: "Laboratori",
    labResults: "Rezultatet",
    labAdmin: "Panel Laborantit",
    serviceHub: "Service Hub",
    inventory: "Inventari",
    jobs: "Ofertat e Punës",
    insurance: "Sigurimet",
    events: "Ngjarjet",
    familyDashboard: "Paneli familjar",
    wallet: "Wallet",
    businessWallet: "Portofoli i Biznesit",
    medimarket: "Medimarket",
    cart: "Shporta",
    seller: "Dyqani im",
    registerBusiness: "Regjistro Biznesin",
    myBlog: "Blogu im",
    postModeration: "Moderimi i Blogut",
    adsManagement: "Menaxhimi i Reklamave",
    invoices: "Faturat",
    messages: "Mesazhet",
    departments: "Departamentet",
    hospitalBeds: "Shtretërit",
    hospitalAdmissions: "Pranimet",
    admin: "Admin",
    verifyDoctors: "Verifikimi i Mjekëve",
    account: "Llogaria",
    businesses: "Bizneset",
    myClinic: "Klinika Ime",
    reportTemplate: "Template i Raportit",
  },
  professionalSettings: {
    tabs: { profile: "Profili", timeline: "Edukimi & Përvoja", skills: "Aftësitë & Gjuhët", social: "Rrjetet Sociale", weekly: "Orari javor", exceptions: "Përjashtimet", security: "Siguria" },
    status: { publicActive: "CV publike aktive", publicInactive: "CV joaktive", verified: "I verifikuar", pendingVerification: "Në pritje verifikimi" },
    actions: { viewPublicCv: "Shiko CV-në publike", marketingView: "Pamja Marketing" },
  },
  invoices: {
    labels: { status: "Statusi" },
    status: { paid: "E paguar", unpaid: "E papaguar", pending: "Në pritje", failed: "Dështuar", cancelled: "E anuluar" },
    medicalService: "Shërbim mjekësor",
    columns: { patient: "Pacienti", service: "Shërbimi", amount: "Shuma", status: "Statusi", date: "Data", actions: "Veprime" },
    list: { title: "Faturat e klinikës", summary: "{{count}} fatura totale · {{amount}} EUR të inkasuar", loadErrorTitle: "Faturat e klinikës nuk u ngarkuan", loadErrorDescription: "Kontrolloni lidhjen ose provoni sërish.", emptyTitle: "Nuk ka fatura ende", emptyDescription: "Faturat do të shfaqen sapo të kryhen pagesat e para nga terminet." },
    actions: { payWithWallet: "Paguaj me Wallet", confirmPayment: "Konfirmo pagesën", paying: "Duke paguar...", cancelRequest: "Anulo kërkesën", cancelRequestDescription: "Kjo do ta anulojë kërkesën e reklamës dhe faturën e papaguar.", cancelling: "Duke anuluar..." },
    detail: { title: "Detajet e faturës", amount: "Shuma", receivedAmount: "Shumë e marrë", paidAmount: "Shumë e paguar", transactionId: "ID transaksioni", type: "Lloji", credit: "Hyrje (Credit)", debit: "Dalje (Debit)", description: "Përshkrimi", reference: "Referenca", createdAt: "Data e krijimit", completedAt: "Data e përfundimit", balanceBefore: "Gjendja para", balanceAfter: "Gjendja pas", generatingPdf: "Duke gjeneruar...", pdfGenerationFailed: "PDF nuk u gjenerua. Provoni sërish.", pdfUnavailable: "PDF-ja është e disponueshme vetëm për transaksione debit." },
  },
  modules: {
    connecting: "Ky modul është në fazë lidhjeje",
    appointments: "Terminet Mjekësore",
    monitoring: "Monitorimi Shëndetësor",
    laboratory: "Laboratori",
    insurance: "Sigurimet Shëndetësore",
    events: "Ngjarjet & Webinaret",
    jobs: "Platforma e Punësimit",
    inventory: "Inventari Mjekësor",
    serviceHub: "Qendra e Shërbimeve",
    wallet: "Portofoli Dixhital",
    medimarket: "Tregu Mjekësor",
    messages: "Mesazhet",
    clinical: "Historia Klinike",
    family: "Kujdesi Familjar",
    imaging: "Imazheritë Mjekësore",
  },
  appointments: {
    title: "Terminet Mjekësore",
    book: "Rezervo Termin",
    upcoming: "Terminet e ardhshme",
    past: "Terminet e kaluara",
    confirmed: "I konfirmuar",
    requested: "Kërkesë dërguar",
    completed: "I kryer",
    cancelled: "I anuluar",
    noAppointments: "Nuk ka termine të planifikuara",
    selectDoctor: "Zgjidhni mjekun",
    selectDate: "Zgjidhni datën",
    selectTime: "Zgjidhni orën",
    confirmPayment: "Konfirmo dhe paguaj me Wallet",
    insufficientFunds: "Balancë e pamjaftueshme",
    addFunds: "Shto kredi →",
    patientList: { eyebrow: "Terminet e pacientit", title: "Rezervimet dhe pagesat", createPatient: "Krijo pacient", total: "Gjithsej", totalDescription: "Terme të regjistruara në llogarinë tuaj.", confirmed: "Të konfirmuara", confirmedDescription: "Rezervime të paguara dhe të bllokuara.", pending: "Në pritje", pendingDescription: "Rezervime që presin pagesën.", historyTitle: "Historiku i termineve", historyDescription: "Statusi, koha dhe pagesa e çdo rezervimi.", emptyTitle: "Nuk ka termine ende", emptyDescription: "Sapo të rezervoni terminin e parë, ai do të shfaqet këtu.", doctorBusiness: "Mjeku #{{doctorId}} · Biznesi #{{businessId}}", service: "Shërbimi #{{serviceId}}", openWorkbench: "Hap Workbench", starts: "Fillon", ends: "Mbaron", invoice: "Fatura", noInvoice: "Ende pa faturë" },
    confirmation: { stepTitle: "Hapi 4 · Konfirmimi", stepDescription: "Rezervimi bëhet real vetëm pasi pagesa nga Wallet të kryhet.", clinic: "Klinika", service: "Shërbimi", doctor: "Mjeku", specialization: "Specializimi", date: "Data", time: "Ora", price: "Çmimi", selectClinic: "Zgjidhni klinikën", selectService: "Zgjidhni shërbimin", selectSlot: "Zgjidhni slot-in", willAppear: "Do të shfaqet", walletNotice: "Pagesa nga Wallet-i kryhet vetëm pasi të konfirmoni. Balanca nuk ndryshon derisa backend-i ta kthejë vlerën e re.", referenceOptional: "Referenca (opsionale)", referencePlaceholder: "p.sh. Kontroll kardiologjik", insufficientFundsDescription: "Wallet nuk ka mjaftueshëm kredi.", warning: "Kujdes", lowBalance: "Balanca ({{balance}}) mund të mos mjaftojë ({{amount}})." },
  },
  insurance: {
    title: "Sigurimet Shëndetësore",
    active: "Polica Aktive",
    coverage: "Mbulim i mundshëm",
    noPolicy: "Nuk ka policë aktive",
    covered: "I mbuluar",
    partial: "Mbulim i pjesshëm",
    notCovered: "Pa mbulim",
    viewPolicy: "Shiko policën",
    contact: "Kontakto sigurimin",
    calculate: "Kalkulato",
    widgetTitle: "Mbulimi i Sigurimit",
    check: "Kontrollo",
    checking: "Duke kontrolluar...",
    insurerCovers: "Sigurimi mbulon",
    youPay: "Ju paguani",
    policyLabel: "Polica",
    noActivePolicy: "Nuk keni policë aktive sigurimi.",
  },
  events: {
    title: "Ngjarjet & Webinaret",
    register: "Regjistrohu",
    registered: "✓ E regjistruar",
    registering: "Duke regjistruar...",
    full: "Vendi është plotësuar.",
    free: "Falas",
    online: "Online",
    inPerson: "Prezencë",
    hybrid: "Hibrid",
    webinar: "Webinar",
    conference: "Konferencë",
    training: "Trajnim",
    workshop: "Punëtori",
    seminar: "Seminar",
    noEvents: "Nuk ka ngjarje aktive",
  },
  jobs: {
    title: "Platforma e Punësimit",
    apply: "Apliko",
    applying: "Duke aplikuar...",
    applied: "✓ Aplikova",
    fullTime: "Kohë e plotë",
    partTime: "Kohë e pjesshme",
    contract: "Kontratë",
    onSite: "Prezencë",
    remote: "Largsi",
    hybrid: "Hibrid",
    salary: "Paga",
    noOffers: "Nuk ka oferta aktive",
  },
  search: {
    title:          "Kërkim Inteligjent",
    placeholder:    "Kërko mjekun, klinikën ose specialitetin...",
    placeholderShort: "Kërko mjek, klinikë...",
    verified:       "I verifikuar",
    viewProfile:    "Shiko profilin",
    publicProfile:  "Profil publik aktiv",
    noResults:      "Nuk u gjetën rezultate.",
    filters:        "Filtra",
    advancedFilters:"Filtra Avancuar",
    radius:         "Rrezja (km)",
    gender:         "Gjinia",
    any:            "Çdo",
    female:         "Femër",
    male:           "Mashkull",
    tabs: {
      all:           "Të gjitha",
      professionals: "Mjekë",
      clinics:       "Klinika",
    },
    cities: {
      all:          "Të gjitha qytetet",
      prishtina:    "Prishtinë",
      prizren:      "Prizren",
      gjilan:       "Gjilan",
      peja:         "Pejë",
      mitrovica:    "Mitrovicë",
    },
  },

  laboratory: {
    title:          "Laboratori",
    pageDesc:       "Zgjidhni kategoritë, selektoni analizat dhe dorëzoni kërkesën.",
    selectAtLeastOne: "Zgjidhni të paktën 1 analizë.",
    myOrders:       "Porositë e mia",
    myOrdersDesc:   "Statusi i analizave pas pagesës me Wallet.",
    noMyOrders:     "Nuk keni porosi laboratorike ende.",
    tests:          "analiza",
    selfOrder:      "Self-order",
    panelTitle:     "Panel Laborantit",
    ordersTitle:    "Porositë e Analizave",
    ordersDesc:     "Lista e plotë e porosive — fut rezultatet për porositë aktive.",
    noOrders:       "Nuk ka porosi aktive",
    noOrdersHint:   "Porositë e reja do të shfaqen këtu sapo pacientët të dërgojnë kërkesa.",
    tableHeaders: {
      case:         "Rasti",
      patient:      "Pacienti",
      package:      "Paketa",
      doctor:       "Doktori",
      status:       "Statusi",
      time:         "Koha",
      actions:      "Veprime",
    },
    results:        "Rezultatet",
    enterResults:   "Fut Rezultate",
    confirmResults: "Konfirmo Rezultatet",
    saving:         "Duke ruajtur...",
    close:          "Mbyll",
    valueRequired:  "Vlera kërkohet.",
    dateRequired:   "Data e ekzekutimit kërkohet.",
    filters: {
      status:       "Statusi",
    },
    form: {
      performedAt:  "Data e ekzekutimit",
      value:        "Vlera *",
      unit:         "Njësia",
      reference:    "Referencë (min-max)",
      note:         "Shënim",
      laboratoryNote: "Shënim i laboratorit (opsional)",
      notePlaceholder: "Vëzhgime shtesë...",
    },
    levels: {
      high:         "Lartë",
      normal:       "Normal",
      low:          "Ulët",
    },
    orderStatuses: {
      received:      "Marrë",
      in_progress:   "Në proces",
      results_ready: "Gati",
      delivered:     "Dorëzuar",
      cancelled:     "Anuluar",
    },
  },

  admin: {
    title:          "Control Room",
    auditTrail:     "Audit Trail",
    allDomains:     "Të gjitha domenët",
    allSeverities:  "Çdo severity",
    recentEvents:   "ngjarje të fundit",
    noEvents:       "Nuk ka ngjarje të regjistruara.",
    growth: {
      title:        "Llogari të Reja — 7 Ditët e Fundit",
      noData:       "Nuk ka regjistrime në 7 ditët e fundit.",
      newAccounts:  "Llogari të reja",
    },
    kpi: {
      totalAccounts:   "Total Llogari",
      activeAccounts:  "llogari aktive në sistem",
      appointments:    "Termine (muaji)",
      appointmentsSub: "termine të kryera",
      volume:          "Volumi Financiar",
      volumeSub:       "transaksione muajit",
    },
  },

  wallet: {
    cardLink: { title: "Karta bankare", connect: "Lidh kartën", change: "Ndërro kartën", expires: "skadon", description: "Për pagesa dhe fatura të shpejta." },
    title: "Portofoli Dixhital",
    eyebrow: "E-Wallet",
    financialTitle: "Portofoli Financiar",
    financialDescription: "Balanca, analitika dhe pagesat menaxhohen ne kohe reale.",
    notFoundTitle: "Wallet nuk u gjet",
    notFoundDescription: "Balanca nuk mund te lexohet per momentin. Provoni perseri pas pak.",
    balance: "Balanca",
    topUp: "Rimbush",
    history: "Historia e transaksioneve",
    noTransactions: "Nuk ka transaksione",
    credit: "Kredi",
    debit: "Debi",
    completed: "I kompletuar",
    pending: "Në pritje",
    failed: "I dështuar",
    insufficientFunds: "Balancë e pamjaftueshme në Wallet.",
    invoicePaid: "Fatura u pagua me sukses.",
    paymentSuccess: "Pagesa u krye me sukses.",
    totalBalance: "Balanca totale",
    myQrCode: "Kodi im QR",
    transactions: "Transaksione",
    activeSessions: "Sesione aktive",
    activeRefs: "Referenca aktive",
    qrSubtitle: "Skano per transfere te shpejta",
    qr: { scanHint: "Skano me aplikacionin bankar ose mjekësor për transfer të shpejtë." },
  },
  auth: {
    resetEmailSent: "Nëse llogaria ekziston, një email me udhëzime është dërguar.",
    passwordChangedSuccess: "Fjalëkalimi u ndryshua me sukses. Tani mund të kyçeni.",
  },
  errors: {
    VERIFIED_PROFILE_REQUIRED: "Llogaria juaj është në shqyrtim. Postimi do të lejohet sapo të verifikoheni.",
    INSUFFICIENT_FUNDS: "Nuk keni mjete të mjaftueshme në Wallet për këtë veprim.",
    ACCESS_DENIED: "Nuk keni autorizim për të hyrë në këtë seksion.",
    ALREADY_EXISTS: "Ky informacion ekziston tashmë në sistem.",
    EMAIL_ALREADY_EXISTS: "Ky email është tashmë i regjistruar. Provoni të kyçeni ose përdorni një email tjetër.",
    NOT_FOUND: "Burimi i kërkuar nuk u gjet.",
    generic: "Ndodhi një gabim. Ju lutem provoni sërish.",
    network: "Problem me lidhjen. Kontrolloni internetin.",
    unauthorized: "Sesioni ka skaduar. Ju lutem kyçuni sërish.",
    notFound: "Faqja nuk u gjet.",
    insufficientFunds: "Balancë e pamjaftueshme në Wallet.",
    forbidden: "Nuk keni leje për këtë veprim.",
    invalidFileType: "Skedari i ngarkuar nuk është një imazh ose video valide.",
    reportNotFound: "Raporti nuk u gjet.",
    REPORT_REQUIRED_FIELDS_MISSING: "Plotesoni fushat e detyrueshme para nenshkrimit.",
    fieldLocked: "Gabim: fusha e bllokuar nuk mund të fshihet.",
    clinicalAccessDenied: "Qasja e ndaluar: Ky seksion përmban të dhëna private klinike.",
    retention_policy_active: "Raportet e finalizuara mjekesore nuk mund te fshihen per arsye ligjore.",
    hospitalMetadataRequired: "Raporti spitalor nuk mund të nënshkruhet pa të dhënat e shtrimit.",
    bedAlreadyOccupied: "Shtrati është i zënë.",
    invalidResetToken: "Ky link është i pavlefshëm ose ka skaduar.",
  },
  logs: {
    accessGranted: "Qasje e lejuar",
  },

  pages: {
    lab:       { eyebrow: 'Laboratori',              title: 'Rezultatet e analizave',   description: 'Të dhënat e fundit klinike me statuse të llogarituara nga sistemi.' },
    events:    { eyebrow: 'Platforma Mjekësore',     title: 'Ngjarjet & Webinaret',     description: 'Webinarë, konferenca dhe trajnime mjekësore live dhe të regjistruara.' },
    jobs:      { eyebrow: 'Platforma Mjekësore',     title: 'Ofertat e Punës',          description: 'Mundësi punësimi dhe karrierë në sektorin e shëndetësisë.' },
    insurance: { eyebrow: 'Sigurimet Shëndetësore',  title: 'Portali i Sigurimeve',     description: 'Polica dhe mbulimi juaj shëndetësor nga partnerët e Kosovës.' },
    wallet:    { eyebrow: 'Portofoli Dixhital',      title: 'Wallet',                   description: 'Menaxhoni balancën, transaksionet dhe pagesat mjekësore.' },
    favorites: { eyebrow: 'Preferencat',             title: 'Lista e preferencave',     description: 'Mjekët, klinikat dhe produktet që keni ruajtur.' },
    inventory: { eyebrow: 'Asete Mjekësore',         title: 'Smart Inventory',          description: 'Menaxhimi i pajisjeve mjekësore me QR dhe historikun e gjendjes.' },
    serviceHub:{ eyebrow: 'Qendra e Shërbimeve',     title: 'Service Hub',              description: 'Aktivizoni dhe menaxhoni modulet e platformës për klinikën tuaj.' },
    monitoring:{ eyebrow: 'Monitorimi Shëndetësor',  title: 'Monitorimi',               description: 'Matje dhe ndjekje e parametrave shëndetësorë në kohë reale.' },
  },

  corporate: {
    title: "Dashboard Korporativ",
    subtitle: "Pamja e konsoliduar e të gjitha degëve",
    tabs: {
      overview:  "Krahasimi",
      map:       "Harta",
      branches:  "Degët",
      pending:   "Kërkesat",
    },
    kpi: {
      branches:    "Degë",
      doctors:     "Mjekë",
      appointments:"Termine",
      revenue:     "Të Ardhura",
      activeSub:   "klinika aktive",
      staffMedical:"stafi mjekësor",
      allBranches: "të gjitha degët",
      combinedEur: "të kombinuara EUR",
    },
    createOrg:   "Organizatë e Re",
    noBranches:  "Nuk ka degë të regjistruara akoma.",
    noOrgs:      "Nuk keni organizata të regjistruara.",
    noOrgsHint:  "Krijoni një organizatë dhe shtoni klinkat tuaja si degë.",
    createFirst: "Krijo Organizatën e Parë",
    requestJoin: "Kërkesa u dërgua. Prit aprovimin.",
    approved:    "Aprovuar",
    denied:      "Refuzuar",
    pending:     "Në pritje",
  },

  about: {
    title:    "Rreth eShendetesisë",
    subtitle: "Platforma shëndetësore kryesore e Kosovës",
    mission:  "Misioni ynë është të lidhim pacientët me profesionistët shëndetësorë në mënyrën më efikase dhe të sigurt.",
    vision:   "Vizion",
    visionText: "Kujdes shëndetësor i arritshëm për çdo qytetar të Kosovës.",
    team:     "Ekipi ynë",
    contact:  "Kontakt",
  },

  monitoring: {
    session:     "Seanca e Monitorimit",
    sessions:    "Seancat",
    entries:     "Matjet",
    noSessions:  "Nuk ka seanca aktive.",
    noEntries:   "Nuk ka matje për këtë seancë.",
    shareWith:   "Ndaj me mjekun",
    revokeAccess:"Revokon Qasjen",
    grantActive: "Qasje aktive",
    grantNone:   "Pa qasje të dhënë",
    metrics: {
      heartRate:  "Rrahjet e zemrës",
      bloodPressure: "Presioni i gjakut",
      glucose:    "Glukoza",
      weight:     "Pesha",
      temperature:"Temperatura",
    },
  },

  clinical: {
    reportEditor: {
      titleLabel: "Titulli i raportit",
      summaryLabel: "Anamneza / Permbledhja",
      diagnosisLabel: "Diagnoza / Vleresimi klinik",
      recommendationsLabel: "Rekomandimet",
      markdownHint: "Markdown: **trashe**, *italic*, - lista",
      saveDraft: "Ruaj draftin",
      signAndFinalize: "Nenshkruaj dhe Finalizo",
      verificationPendingTitle: "Verifikimi i llogarisë është në pritje.",
      verificationPendingDescription: "Nuk mund të nënshkruani raporte.",
      auditNotice: "Ky raport eshte i nenshkruar ne menyre elektronike sipas Rregullores se Auditit Klinik.",
      finalizeTitle: "Nenshkruaj dhe finalizo raportin",
      finalizeDescription: "Pasi te nenshkruhet, raporti behet read-only dhe qasja regjistrohet ne audit.",
      finalizing: "Duke finalizuar...",
      finalizeConfirm: "Finalizo raportin",
      validationTitle: "Titulli duhet te kete te pakten 3 karaktere.",
      specialistOnly: "Vetëm specialistët mund të nënshkruajnë raportin.",
      specialistOnlyTitle: "Nënshkrimi kërkon rol specialisti",
      specialistOnlyDescription: "Mjekët e përgjithshëm mund ta ruajnë raportin si draft, por finalizimi bëhet vetëm nga specialisti.",
    },
    title:       "Historia Klinike",
    diagnoses:   "Diagnozat",
    reports:     "Raportet",
    medications: "Ilaçet",
    noDiagnoses: "Nuk ka diagnoza të regjistruara.",
    noReports:   "Nuk ka raporte klinike.",
    addDiagnosis:"Shto Diagnozë",
    requestLabs: "Kërko Analiza",
    viewReport:  "Shiko Raportin",
    downloadPdf: "Shkarko PDF",
    signReport:  "Nënshkruaj Raportin",
    icdCode:     "Kodi ICD-10",
    confirmedAt: "Konfirmuar më",
  },

  subscriptionExpiry: {
    days15: "Keni 15 ditë afat para skadimit të abonimit.",
    days7: "Keni 7 ditë afat para skadimit të abonimit.",
    days3: "Urgjent: keni 3 ditë afat para bllokimit të moduleve.",
    expired: "Abonimi ka skaduar dhe qasja në module është bllokuar.",
  },

  posts: {
    patientQuestion: "Pyetje nga Pacienti",
    professionalPost: "Postim Profesional",
    summaryLabel: "Përmbledhje e shkurtër",
    officialBadge: "Artikull zyrtar",
    patientBadge: "Pyetje nga pacienti",
    rejectionReason: "Arsyeja e refuzimit",
    unverifiedAlert: "Postimi juaj është në pritje të aprovimit",
    commentRestricted: "Vetëm profesionistët mund të komentojnë në këtë artikull",
    rejectionTitle: "Refuzuar",
    status: {
      published: "Publikuar",
      pending: "Ne pritje te aprovimit",
      rejected: "Refuzuar",
      draft: "Draft",
      scheduled: "I planifikuar",
      expiring: "Ne skadim",
      expired: "I skaduar",
    },
    rejectionFallback: "Postimi kërkon korrigjim para publikimit.",
    moderation: {
      title: "Moderimi i Postimeve",
      description: "Postimet hyjnë këtu si në pritje dhe dalin në Showcase vetëm pas aprovimit.",
      empty: "Nuk ka postime në pritje për shqyrtim.",
      archiveEmpty: "Nuk ka postime të aprovuara ose të refuzuara.",
      untitled: "Pa titull",
      approvePublish: "Aprovo dhe publiko",
      reject: "Refuzo",
      rejectTitle: "Refuzo postimin",
      rejectDescription: "Zgjidh arsyen që do t'i shfaqet autorit. Refuzimi nuk e fshin postimin.",
      extraNote: "Shënim shtesë për autorin",
      rejectWithReason: "Refuzo me arsye",
      tabs: {
        pending: "Në Pritje",
        archive: "Aktive",
      },
      reasons: {
        inaccurate: "Informacion i pasaktë",
        unethical: "Përmbajtje jo-etike",
        promotional: "Përmbajtje promocionale e palejuar",
      },
    },
  },

  access: {
    unauthorized_role: "Ky rol nuk ka qasje ne dosjen klinike te pacientit.",
    relationship_required: "Kerkohet marredhenie klinike ose grant aktiv nga pacienti.",
    requestNewGrant: "Kerko Grant te ri per qasje",
    clinicalForbidden: {
      title: "Qasje e Ndaluar",
      description: "Ky seksion permban te dhena private klinike.",
    },
    moduleInactive: {
      title: "Moduli nuk eshte aktivizuar ende",
      description: "Backend e raporton kete modul si jo aktiv per momentin.",
    },
    profileRequired: {
      title: "Duhet te zgjidhni nje profil aktiv",
      description: "Ky seksion varet nga konteksti i profilit qe backend-i raporton per sesionin tuaj.",
    },
    permissionMissing: {
      title: "Leja e kerkuar mungon",
      description: "Ky seksion kerkon: {{permissions}}. Kontaktoni administratorin.",
    },
    denied: {
      title: 'Seksion i Izoluar',
      description: 'Ky është në seksion i izoluar {{role}}. Ju nuk keni autorizim për këtë kontekst.',
    },
    clinicalIsolation: {
      title: 'Qasje Klinike e Bllokuar',
      description: 'Administratoret nuk kanë qasje në të dhëna klinike (Kushtetuta §III). Roli juaj: {{role}}.',
    },
    notVerified: 'Profili juaj nuk është verifikuar ende nga administratori.',
    technicianBlock: 'Mbrojtja e Privatësisë: Ky seksion (Agjenda/Workbench) është i rezervuar vetëm për stafin mjekësor specialist.',
    pendingVerification: 'Prit Verifikimin',
    switchBusiness: 'Kalon te Modaliteti i Biznesit',
    switchClinical: 'Kthehu te Modaliteti Klinik',
    businessMode: 'Modaliteti i Biznesit',
    clinicalMode: 'Modaliteti Klinik',
  },
};


